import { Outlet } from 'react-router'
import { Menu } from 'lucide-react'
import { AdminSidebar, AdminSidebarContent } from '@/components/AdminSidebar'
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet'

export default function AdminLayout() {
  return (
    <div className='flex h-screen bg-[#EDEFF3]'>
      {/* Sidebar - Desktop */}
      <AdminSidebar />

      {/* Main Content */}
      <div className='flex-1 flex flex-col overflow-hidden'>
        {/* Mobile top bar with hamburger menu */}
        <div className='lg:hidden flex items-center px-4 py-3 bg-white border-b border-[#E5E7EB]'>
          <Sheet>
            <SheetTrigger asChild>
              <button className='p-2 hover:bg-gray-100 rounded-lg transition-colors'>
                <Menu className='h-6 w-6 text-gray-700' />
              </button>
            </SheetTrigger>
            <SheetContent side='left' className='p-0 w-[300px]'>
              <AdminSidebarContent />
            </SheetContent>
          </Sheet>
        </div>
        <main className='flex-1 overflow-y-auto'>
          <Outlet />
        </main>
      </div>
    </div>
  )
}
